import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { Form, Button, Row, Col } from 'antd';
import React, { useState } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { getMyMemberListByName } from '../../api/constlink';
import { ProjectConfig } from '../../modules/projects';
import { DebounceSelect } from '../common/DebounceSelectComponent';

const StyledDiv = styled.div`
  .dynamic-delete-button {
    position: relative;
    top: 4px;
    margin: 0 8px;
    color: #999;
    font-size: 24px;
    cursor: pointer;
    transition: all 0.3s;
  }
  .dynamic-delete-button:hover {
    color: #777;
  }
  .dynamic-delete-button[disabled] {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

interface ProjectConfigEditComponentProps extends RouteComponentProps {
  onUpdate: (config: any) => void;
  enterpriseId: string;
  projectId: string;
  projectConfig: ProjectConfig;
}

function ProjectConfigEditComponent({
  enterpriseId,
  projectId,
  projectConfig,
  onUpdate,
}: ProjectConfigEditComponentProps) {
  const [form] = Form.useForm();
  const [approvalLines, setApprovalLines] = useState();

  return (
    <StyledDiv>
      <Row>
        <Col>
          <h2>공사 설정</h2>
        </Col>
      </Row>
      <Row>
        <Col>
          <h3>전자결재 결재선</h3>
          <p>
            낮은 직급부터 입력 하세요. 오른쪽으로 갈수록 직급이 높아져야 합니다.
          </p>
          <p></p>
        </Col>
      </Row>

      <Form
        form={form}
        layout="vertical"
        name="control-hooks"
        onFinish={onUpdate}
        initialValues={projectConfig.config}
      >
        <Form.List name="approvalLines">
          {(fields, { add, remove }, { errors }) => (
            <>
              {fields.map((field, index) => (
                <Form.Item required={false} key={field.key}>
                  <Row justify="space-between">
                    <Col span={11}>
                      <Row>
                        <Col span={22}>
                          <Form.Item
                            {...field}
                            validateTrigger={['onChange', 'onBlur']}
                            rules={[
                              {
                                validator: async (_, approvalLines) => {
                                  if (
                                    !approvalLines ||
                                    approvalLines.length < 1
                                  ) {
                                    return Promise.reject(
                                      new Error('결재자를 선택하세요.'),
                                    );
                                  }
                                },
                              },
                            ]}
                          >
                            <DebounceSelect
                              mode="multiple"
                              value={approvalLines}
                              enterpriseId={enterpriseId}
                              projectId={projectId}
                              placeholder="결재자를 순서대로 입력 하세요."
                              fetchOptions={getMyMemberListByName}
                              onChange={(newData) => {
                                setApprovalLines(newData);
                              }}
                              style={{ width: '100%' }}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={2}>
                          <MinusCircleOutlined
                            className="dynamic-delete-button"
                            onClick={() => remove(field.name)}
                            rev={undefined}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Form.Item>
              ))}
              <Row justify="space-between">
                <Col span={11}>
                  <Form.Item>
                    <Button
                      type="dashed"
                      onClick={() => add()}
                      style={{ width: '60%' }}
                      icon={<PlusOutlined rev={undefined} />}
                    >
                      결재선 추가
                    </Button>
                    <Form.ErrorList errors={errors} />
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}
        </Form.List>
        <Row justify="center">
          <Col>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                style={{ width: '400px', marginTop: '30px' }}
              >
                저장
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </StyledDiv>
  );
}

export default withRouter(ProjectConfigEditComponent);
